module.exports = __webpack_public_path__ + "static/img/help-img5.dc55a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help-img5.jpg
// module id = 582
// module chunks = 0